import { useState, useEffect, useCallback } from 'react';
import Table from '../../common/table';
import NoEquipAlert from '../../common/returns/NoEquipAlert';

import apiBombasVacuo from '../../../services/apis/apiBombaVacuo';

const TableBombasVacuo = ({ unidadeId, regimes, condensacao }) => {
	const [bombasData, setBombasData] = useState([]);

	const fetchData = useCallback(async () => {
		if (!unidadeId && !condensacao && !regimes) return;
		try {
			const res = await apiBombasVacuo.findAll(unidadeId);
			setBombasData(res.data);
		} catch (error) {
			console.error(`Error fetching bombas: ${error}`);
		}
	}, [unidadeId, condensacao, regimes]);

	useEffect(() => {
		fetchData();
	}, [fetchData]);

	return (
		<div className="w-full">
			{bombasData.length > 0 ? (
				<Table.Root>
					<Table.Head>
						<Table.Header>Nome</Table.Header>
						{/* <Table.Header>Regime</Table.Header> */}
						<Table.Header>Marca</Table.Header>
						<Table.Header>Modelo</Table.Header>
						<Table.Header>Potência</Table.Header>
					</Table.Head>

					<Table.Body>
						{bombasData.map((bomba) => (
							<Table.Row key={bomba.id}>
								<Table.Data>
									{bomba.nome}
								</Table.Data>
								<Table.Data>
									{bomba.modelo.marca.nome}
								</Table.Data>
								<Table.Data>
									{bomba.modelo.nome}
								</Table.Data>
								<Table.Data>
									{bomba.potenciaNominal +
										' CV'}
								</Table.Data>
							</Table.Row>
						))}
					</Table.Body>
				</Table.Root>
			) : (
				<NoEquipAlert equipments="bombas" />
			)}
		</div>
	);
};

export default TableBombasVacuo;
